<template>
  <div class="profile" v-if="loggedIn">
    <div class="user">
      {{ session.email }}
    </div>
    <a href="#" @click.prevent="logout">
      Log Out
    </a>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { authComputed } from "@/store/helpers.js";

export default {
  computed: {
    ...mapState(["session"]),
    ...authComputed
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({
          name: "Login"
        });
      });
    }
  }
};
</script>
